import getSnapshotsDatesSlice from './getSnapshotsDatesSlice';
import getSnapshotSlice from './getSnapshotSlice';

const snapshotsSlices = [getSnapshotsDatesSlice, getSnapshotSlice];

export default snapshotsSlices;
